<template>
  <div class="loginApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="授权登录中，请稍后..." element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading"></div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: true,
        wxcode:'',
      };
    },
    beforeMount() {
      var code = this.codefun('code');
      if(!code){
        var url = encodeURIComponent('http://user.laife.cn/main/login');
        window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf57bae009c299252&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
        return;
      }else{
        this.wxcode = code;
      }
    },
    mounted() {
      this.beforeMount();
      if(this.wxcode != ''){
        this.login();
      }
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      login:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'wx/login/index',
          params:{
            wxcode:that.wxcode
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          var res = response.data;
          if(res.status == 200){
            localStorage.setItem('userjwt', JSON.stringify(res.data));
            that.$router.go(-1)
          }else{
            that.$message.error(res.message);
          }
          
        }).catch(err=>{
          that.fullscreenLoading = false;
            console.log('请求失败:'+err);
        });
        return false;
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .el-message--error{
    top:auto !important;
    bottom:20px !important;
    min-width:auto !important;
  }
  .el-message{
    transition: opacity .3s,transform .4s,bottom .4s !important;
  }
  .loginApp{
    max-width:640px;
    background:#141325;
    margin:0 auto;
  }
</style>